import { useTranslation } from 'react-i18next';

import { Container, ErrorState, Header } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

export const ErrorBoundary = () => {
  const { t } = useTranslation(['quotations']);

  return (
    <>
      <Header.Root>
        <Header.Content backTo={routes.quotations} title={t('quotations:createEdit.title.edit')} />
      </Header.Root>

      <Container>
        <ErrorState onRetry={() => window.location.reload()} title={t('quotations:createEdit.error.title')} />
      </Container>
    </>
  );
};
